import React from "react";

function ViewProfileImage({ url, width, height }) {
  return (
    <div style={{ textAlign: "center" }}>
      <img
        style={{ maxWidth: width || "100%", maxHeight: height || "100%" }}
        src={url}
        alt="preview"
      />
    </div>
  );
}

export { ViewProfileImage };
